import { createRouter, createWebHistory, type Router } from 'vue-router';

import { legacyRoutes } from './legacyRoutes';
import { routes } from './routes';

export const ENTRY_ROUTE_NAME = 'entry';

export function createAppRouter(): Router {
  return createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: '/:pathMatch(.*)*',
        name: ENTRY_ROUTE_NAME,
        component: () => import('../views/CheckinEntryPage.vue')
      }
    ]
  });
}

export function installRoutes(router: Router, useNewCometRoutes: boolean): void {
  const table = useNewCometRoutes ? routes : legacyRoutes;
  table.forEach(route => router.addRoute(route));
  router.removeRoute(ENTRY_ROUTE_NAME);
}
